var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompleteRequestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.75 98.5275L70.3612 89.1388L65.25 94.25L79.75 108.75L108.75 79.75L103.639 74.6388L79.75 98.5275Z",
    fill: "#90EAEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.625 18.125H79.75V14.5C79.7443 12.5789 78.9786 10.7382 77.6202 9.37981C76.2618 8.02142 74.4211 7.25574 72.5 7.25H43.5C41.5789 7.25574 39.7382 8.02142 38.3798 9.37981C37.0214 10.7382 36.2557 12.5789 36.25 14.5V18.125H25.375C23.4539 18.1307 21.6132 18.8964 20.2548 20.2548C18.8964 21.6132 18.1307 23.4539 18.125 25.375V101.5C18.1307 103.421 18.8964 105.262 20.2548 106.62C21.6132 107.979 23.4539 108.744 25.375 108.75H58V101.5H25.375V25.375H36.25V36.25H79.75V25.375H90.625V65.25H97.875V25.375C97.8693 23.4539 97.1036 21.6132 95.7452 20.2548C94.3868 18.8964 92.5461 18.1307 90.625 18.125ZM72.5 29H43.5V14.5H72.5V29Z",
    fill: "#90EAEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteRequestIcon);
export default __webpack_public_path__ + "static/media/completeRequestIcon.860f558d72c02bddbb33046ffb98c7f6.svg";
export { ForwardRef as ReactComponent };